import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { URL_CUSTOMER_PROFILE } from '@shared/contants'
import { useLocalizedNavigate as useNavigate } from '@shared/lib/locale'

export default function VerificationSuccess ({
  metadata,
}: {
  metadata?: Record<string, unknown>
}) {
  const { t } = useTranslation('payment')
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(URL_CUSTOMER_PROFILE)
    }, 3000)

    return () => clearTimeout(timer)
  }, [ navigate ])

  return (
    <div className="verification-success">
      <div className="verification-success__icon">✓</div>
      <h1 className="verification-success__title">
        {t('verification.success.title')}
      </h1>
      <p className="verification-success__message">
        {String(t('verification.success.message'))}
      </p>
      {metadata?.paymentMethodId ? (
        <p className="verification-success__details">
          {String(t('verification.success.payment_method_id'))}: {String(metadata.paymentMethodId)}
        </p>
      ) : null}
    </div>
  )
}
